import { render, staticRenderFns } from "./ModalConfirmAsset.vue?vue&type=template&id=55bb463b"
import script from "./ModalConfirmAsset.vue?vue&type=script&lang=js"
export * from "./ModalConfirmAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports